<template>
    <v-container class="pt-0">
        <div id="go_FlightDetails">
        <v-expansion-panel>
            <v-expansion-panel-content>
                <template v-slot:header>
                    <div><h2 :style="'color:' + theme.primary.base">Flight Details</h2></div>
                </template>
                <v-card :class="(isMobile? 'pl-3 pr-1':'pl-5 pr-5') + ' pb-4' "  v-for="(flightDetails,indgrp) in flightDetailsM" :key="indgrp">
                    <v-layout row wrap style="margin: 5px 0 5px 0;">
                        <v-flex><h3>Departure</h3></v-flex>
                    </v-layout>
                    <v-layout row wrap v-for="(flight,index) in flightDetails.flightsOfDeparture" :key="'D'+index" style="margin-bottom:10px;">
                        <v-flex xs12 sm12 md2>
                            <img style="min-width:48px;min-height:24px; max-width:150px;max-height:100px;" :src="'http://image.galileo.co.th/Airline/'+ flight.airline + '.png'">
                            <!-- <div style="text-align:center;">{{flight.airline}} ({{flight.flightNo}})</div> -->
                        </v-flex>
                        <v-flex xs6 sm6 md3>
                            <ul :style="'padding-left:' + (isMobile? '0px':'24px')">
                                <li><label style="color:blue;">{{helper.dateAndTime.getDateText(flight.origin.date)}}</label> {{helper.dateAndTime.getFourDigitTimeWithColon(flight.origin.time)}}</li>
                                <li>{{flight.origin.airport.name}} ({{flight.origin.airport.code}})</li>
                                <li>Terminal: {{flight.origin.airport.terminal}}</li>
                            </ul>
                        </v-flex>
                        <v-flex v-if="!isMobile" md1 align-self-center>
                            <FlightIcon :directionIndicator="'D'" :width="'24px'" :height="'24px'" color="#c1c1c1" margin="0 50% 0 50%" />
                        </v-flex>
                        <v-flex xs6 sm6 md3>
                            <ul :style="'padding-left:' + (isMobile? '0px':'24px')">
                                <li><label style="color:blue;">{{helper.dateAndTime.getDateText(flight.destination.date)}}</label> {{helper.dateAndTime.getFourDigitTimeWithColon(flight.destination.time)}}</li>
                                <li>{{flight.destination.airport.name}} ({{flight.destination.airport.code}})</li>
                                <li>Terminal: {{flight.destination.airport.terminal}}</li>
                            </ul>
                        </v-flex>  
                        <v-flex xs12 sm12 md3>
                            <SegmentBaggageInfo :segmentBagInfo="segmentBagInfo((index),'D')"></SegmentBaggageInfo>
                        </v-flex>
                        <v-spacer></v-spacer>              
                    </v-layout>                               
                </v-card>                
            </v-expansion-panel-content>
        </v-expansion-panel>

        </div>
    </v-container>   
</template>

<script>
import Helper from '../helper';
import FlightIcon from '../CustomControls/FlighIcon';
import Theme from '../../theme';
import SegmentBaggageInfo from '../CustomControls/SegmentBaggageInfo';

export default {
    props:["flightDetailsM","flightBagInfo"],
    components:{
        FlightIcon, SegmentBaggageInfo,
    },
    data(){return {
        helper:Helper,
        theme:Theme
    }},
    created(){
        //console.log("Flight Details:" + this.flightDetails.flightOfDeparture);
    },
    computed:{
        isMobile(){
            return Helper.display.isMobile(this.$vuetify.breakpoint.name);
        },     
    },    
    methods:{
        segmentBagInfo(segNo,routing){
            let list =[];
            //console.log("segmentBagInfo ***");
            try {
                this.flightBagInfo.forEach((bg,index) => {
                    let lnq = new this.$linq(bg.segments);
                    let bagInfoAry = lnq.where(b=> b.fareId==bg.fareId && b.segment==segNo+1 && b.routing==routing).toArray();

                    let pax = index ==1? "Child":"Adult";
                    pax = index ==2? "Infant":pax;
                    
                    bagInfoAry.forEach(bg => {
                        bg.pax= pax;
                        bg.baggage = bg.bagInfo.split("-")[0];
                        bg.carryOn = bg.bagInfo.split("-")[1];                        
                        list.push(bg);
                    });
                });                
            } catch (error) {
                console.error(error);
            }

            return list;
        },         
    },
}
</script>

<style>
#go_FlightDetails > ul > li > div.v-expansion-panel__body > div > div > div > ul > li{
    list-style: none;
}
</style>